
export const GlobalVariable = Object.freeze({
    //Ambiente Local
     //BASE_API_URL: 'https://localhost:44341/api/',
     //API_Admision: 'https://localhost:44324/api/',

    //Ambiente QA:
    
    BASE_API_URL: 'https://ap02-appcrm2015-qa.azurewebsites.net/api/',
    UrlLogoff: 'https://ap01-appcrm2015-qa.azurewebsites.net',
    API_Admision: 'https://ap03-appcrm2015-qa.azurewebsites.net/api/',
    API_CloudSigner: 'https://qa.cloudsigner.cl/pruebas-santotomasmatricula/',
    bloqueoFinanciero:false,
    bloqueoAcademico:false,
    // AAmbiente Producción:
    //BASE_API_URL: 'https://ap02-appcrm2015.azurewebsites.net/api/',
    //UrlLogoff: 'https://ap04-appcrm2015.azurewebsites.net',
    //API_Admision: 'https://ap03-appcrm2015.azurewebsites.net/api/',
    //API_CloudSigner: 'https://cloudsigner.cl/pruebas-santotomasmatricula/',



    UrlRedireccion: 'https://www.santotomas.cl/',
    TimerToken: 120000 // 1200000 // 20 minutos
});
